import { FC, ReactNode } from 'react';
import { Form, FormItemProps } from 'antd';
import { ScreenShotProps } from '../ScreenShot';
import ScreenShot from 'src/common/components/ScreenShot/index';

export interface DefaultFormItemProps {
  /**
   * @description 字段名，支持数组
   */
  name?: string | number | (string | number)[];
  /**
   * @description label 标签的文本
   */
  label?: ReactNode;
  /**
   * @description 为 true 时不带样式，作为纯字段控件使用
   * @default  false
   */
  noStyle?: boolean;
  /**
   * @description Form.Item中rule属性设置，具体请参考 https://ant.design/components/form-cn/#Rule
   */
  rules?: any[];
  /**
   * @description Form.Item的属性设置，具体请参考 https://ant.design/components/form-cn/#Form.Item
   */
  formItemConfig?: FormItemProps; // Form.Item的其他入参
}


export interface FormScreenShotProps extends DefaultFormItemProps {
  /**
   * @description ScreenShot 的属性配置，具体请参考 src/common/components/ScreenShot/index.tsx
   */
  config?: ScreenShotProps & { ref?: any };
  /**
   * @description 额外插入的外层class
   */
  className?: string;
  /**
   * @description 是否必填
   * @default false
   */
  required?: boolean;
  /**
   * @description 是否禁用
   * @default false
   */
  disabled?: boolean;
  /**
   * @description 颜色变化后触发的回调
   */
  onChange?: Function;
}

/**
 * 表单-截图绘制
 * @category Form
 * @demo
import FormScreenShot from 'src/common/components/Form/FormScreenShot';

<FormScreenShot label='截图：' name='screenShotFiles' rules={[{ required: true, message: '请进行截图' }]} />
 */
const FormScreenShot: FC<FormScreenShotProps> = ({
  label,
  name,
  rules = [],
  formItemConfig = {},
  config = {},
  onChange,
}) => {
  return (
    <Form.Item name={name} label={label} rules={rules} {...formItemConfig}>
      <ScreenShot onChange={(e) => onChange && onChange(e)} {...config} />
    </Form.Item>
  );
};

export default FormScreenShot;
